module.exports = __webpack_public_path__ + "img/9788954430159.86f35cba.jpg";